/**
 * Interface defining the enum network latency.
 */
const enum NetworkLatency {
    Unknown,
    Excellent,
    Good,
    Average,
    Bad,
}

export default NetworkLatency;
